import {
  Add,
  Check,
  CheckBox,
  CheckBoxOutlineBlank,
  ChevronLeft,
  ChevronRight,
  Clear,
  Close,
  Error,
  ErrorOutline,
  ExpandMore,
  Search,
  WarningAmber,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputBase,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInputProps,
  Popover,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
  styled,
  TablePagination,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import React from "react";
import {
  getAllFilters,
  getPaginatedRecords,
  getProductsByUPC,
  updateProducts,
} from "../../services/products";
import { Spinner } from "../shared/Spinner";
import {
  BASE_INPUT,
  CAROUSEL_BTN,
  CAROUSEL_HEADER,
  FILTER_BUTTON,
  INPUT_WRAPPER,
  ITEM_CARD_FILTER_APPLY_BTN,
  ITEM_CARD_FILTER_CLEAR_BTN,
  ITEM_CARD_FILTER_COUNT,
  ITEM_CARD_FILTER_HEADER,
  ITEM_CARD_FILTER_LABEL,
  ITEM_CARD_FILTER_MENU,
  ITEM_CARD_FILTER_MENUITEM,
  ITEM_CARD_FILTER_MENUITEM_WRAPPER,
  ITEM_CARD_FILTER_PAPER,
  ITEM_CARD_FILTER_SELECT,
  ITEM_CARD_FILTER_SELECTION,
  ITEM_CARD_FILTER_SUBHEADER,
  ITEM_CARD_FILTER_TEXT,
  ITEM_CARD_SELECT_MENU,
  PAGINATION_CONTAINER,
  PAGINATION_WRAPPER,
  PRODUCT_FILTER_WRAPPER,
  PRODUCT_WRAPPER,
  SAVE_BTN,
  SELECTION_TEXT,
  TEXT_BTN,
  WARNING_DAILOG_ACTION_NO,
  WARNING_DAILOG_ACTION_TEXT,
  WARNING_DAILOG_ACTION_YES,
  WARNING_DAILOG_HEADER,
  WARNING_DAILOG_TEXT,
  WARNING_DAILOG_TITLE,
  WARNING_DAILOG_WRAPPER,
} from "../styles";
import ItemCard, { BootstrapTooltip } from "./ItemCard";
import _ from "lodash";
import { useAccount, useMsal } from "@azure/msal-react";
import { format } from "date-fns";
import NO_RECORDS from "../../assets/images/no-records.png";
import { ProductStore } from "../../store";
import { view } from "@risingstack/react-easy-state";
import { Virtuoso } from "react-virtuoso";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./carousel.scss";
import PRODUCT_PLACEHOLDER from "../../assets/images/product_placeholder.png";
import { getS3PresignedURL } from "../../services/upload";
import axios from "axios";
import { isValidHttpUrl } from "../../services/helper";
import {
  APPLY_DEFAULT_FILTER,
  DATA_SOURCES,
  DATA_STATUS,
  ROWS_PER_PAGE,
} from "../../utils/constants";

let NEW_PAGE = 1;

const SearchInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: "4px",
    position: "relative",
    backgroundColor: "rgba(255, 255, 255, 0.54)",
    border: "1px solid #ECECEC",
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 500,
    color: "#686C7E",
    width: "100%",
    padding: "6px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      boxShadow: "none",
      borderColor: "1px solid #ECECEC",
    },
  },
}));

const RedditTextField = styled((props: TextFieldProps) => (
  <TextField
    InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
    {...props}
  />
))(() => ({
  "& .MuiFilledInput-root": {
    border: "1px solid rgba(15, 61, 97, 0.1)",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    fontSize: 13,
    lineHeight: "24px",
    fontWeight: 500,
    color: "#282C36",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
    "&.Mui-focused": {
      backgroundColor: "#FFFFFF",
      boxShadow: "none",
      borderColor: "rgba(15, 61, 97, 0.1)",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 500,
    color: "#282C36",
    "&.MuiInputLabel-shrink": {
      fontSize: 14,
      color: "#282C36",
    },
  },
}));

const Products = () => {
  const { accounts } = useMsal();
  const account: any = useAccount(accounts[0] || {});

  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
  const [products, setProducts] = React.useState<any[]>([]);
  const [paginatedProducts, setPaginatedProducts] = React.useState<any[]>([]);
  const [updatedItems, setUpdatedItems] = React.useState<any[]>([]);
  const [selectedProducts, setSelectedProducts] = React.useState<string[]>([]);
  const [searchText, setSearchText] = React.useState<string>("");
  const [evaluateKeys, setEvaluateKeys] = React.useState<any>([]);
  const [totalProducts, setTotalProducts] = React.useState<number>(0);
  const [isFilterLoading, setIsFilterLoading] = React.useState<boolean>(true);

  const [anchorElFilter, setAnchorElFilter] =
    React.useState<HTMLButtonElement | null>(null);
  const [openFilter, setOpenFilter] = React.useState<boolean>(false);

  const [filters, setFilters] = React.useState<any>({});
  const [selectedFilters, setSelectedFilters] = React.useState<any>({});
  const [searchedFilters, setSearchedFilters] = React.useState({
    FileName: "",
    Category: "",
    Brand: "",
  });
  const [selectedFiles, setSelectedFiles] = React.useState<any>([]);
  const [selectedCategories, setSelectedCategories] = React.useState<any>([]);
  const [selectedBrands, setSelectedBrands] = React.useState<any>([]);
  const [selectedSources, setSelectedSources] = React.useState<any>([]);
  const [selectedStatus, setSelectedStatus] = React.useState<any>([]);
  const [isFilterApplied, setIsFilterApplied] = React.useState<boolean>(false);
  const [isAllSelected, setIsAllSelected] = React.useState<boolean>(false);
  const [allPageItemSelected, setAllPageItemSelected] = React.useState<
    boolean[]
  >([false]);

  const [showNavigationWarning, setShowNavigationWarning] =
    React.useState<boolean>(false);
  const [showSelectionWarning, setShowSelectionWarning] =
    React.useState<boolean>(false);
  const [showApprovalWarning, setShowApprovalWarning] =
    React.useState<boolean>(false);
  const [showWarning, setShowWarning] = React.useState<boolean>(false);
  const [showModificationWarning, setShowModificationWarning] =
    React.useState<boolean>(false);
  const [showMassApprovalPending, setShowMassApprovalPending] =
    React.useState<boolean>(false);
  const [modifiedItem, setModifiedItem] = React.useState<any>(null);

  const [brandTerm, setBrandTerm] = React.useState<string>("");
  const [filteredBrands, setFilteredBrands] = React.useState<string[]>([]);
  const [actionName, setActionName] = React.useState("");
  const [noOfRows, setNoOfRows] = React.useState(ROWS_PER_PAGE);

  const [openImageCarousel, setOpenImageCarousel] =
    React.useState<boolean>(false);
  const [imageCarouselUPC, setImageCarouselUPC] = React.useState<string>("");
  const [carouselImages, setCarouselImages] = React.useState<any[]>([]);
  const [selectedCarouselImage, setSelectedCarouselImage] =
    React.useState<number>(0);
  const [deletedImages, setDeletedImages] = React.useState<string[]>([]);
  const [recordDetailsLoading, setRecordDetailsLoading] =
    React.useState<boolean>(false);

  const fetchFilters = async (filters: any = null) => {
    try {
      setIsFilterLoading(true);
      let filterReq = {};
      if (!_.isEmpty(filters)) {
        filterReq = { filters: filters };
      } else if (!_.isEmpty(searchedFilters)) {
        if (
          searchedFilters.Brand !== "" ||
          searchedFilters.Category !== "" ||
          searchedFilters.FileName !== ""
        ) {
          filterReq = { filters: searchedFilters };
        }
      }
      const items: any = await getAllFilters(filterReq);
      if (items?.statusCode === 200) {
        if (!_.isEmpty(items?.body?.body)) {
          setFilters(items?.body?.body);
          setFilteredBrands(items?.body?.body?.Brand || []);
          setIsFilterLoading(false);
          return items?.body?.body;
        }
      } else {
        setFilters([]);
        setFilteredBrands([]);
        setIsFilterLoading(false);
        return null;
      }
      setIsFilterLoading(false);
      return null;
    } catch (error) {
      console.error("[fetchFilters]: ", error);
      setIsFilterLoading(false);
    }
  };

  const getPaginatedProducts = async (
    rows: number,
    key: any,
    count: boolean,
    currentPage: number,
    filterValues: any
  ) => {
    try {
      const filters = _.cloneDeep(filterValues);
      setIsLoading(true);
      let reqPayload: any = {
        Limit: rows < 5 ? ROWS_PER_PAGE : rows,
        Count: count,
      };
      if (!_.isEmpty(key)) {
        reqPayload["LastEvaluatedKey"] = key;
      }
      if (!_.isEmpty(filters)) {
        reqPayload["filters"] = filters;
      }
      const items: any = await getPaginatedRecords(reqPayload);
      if (items?.statusCode === 200) {
        if (!_.isEmpty(items?.body)) {
          let tempKeys = _.clone(evaluateKeys);
          tempKeys[currentPage + 1] = items?.body?.LastEvaluatedKey;
          setEvaluateKeys(tempKeys);
          setTotalProducts(items?.body?.totalRecords);
          setProducts(_.cloneDeep(items?.body?.Items));
          setPaginatedProducts(_.cloneDeep(items?.body?.Items));

          if (isAllSelected) {
            const tempSelectedItems: string[] = [];
            items?.body?.Items.forEach((pr: any) => {
              tempSelectedItems.push(pr.RecordId);
            });

            setSelectedProducts(tempSelectedItems);
            setAllPageItemSelected((prevState) => {
              const newState = [...prevState];
              newState[currentPage] = true;
              return newState;
            });
          } else {
            if (allPageItemSelected[currentPage]) {
              const tempSelectedItems: string[] = [];
              items?.body?.Items.forEach((pr: any) => {
                tempSelectedItems.push(pr.RecordId);
              });
              setSelectedProducts(tempSelectedItems);
            } else {
              setSelectedProducts([]);
              setAllPageItemSelected((prevState) => {
                const newState = [...prevState];
                newState[currentPage] = false;
                return newState;
              });
            }
          }
        }
      } else {
        setEvaluateKeys([]);
        setTotalProducts(0);
        setProducts([]);
        setPaginatedProducts([]);
        setSelectedProducts([]);
        setAllPageItemSelected([false]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("[getPaginatedProducts]: ", error);
      setIsLoading(false);
    }
  };

  const fetchInitialData = async () => {
    await fetchFilters({}).then(async (data) => {
      let tempFiltersReq = {};
      if (APPLY_DEFAULT_FILTER) {
        if (data && !_.isEmpty(data["FileName"])) {
          tempFiltersReq = {
            FileName: [data["FileName"][0]],
          };
          setSelectedFilters(tempFiltersReq);
          setSelectedFiles([data["FileName"][0]]);
          setIsFilterApplied(true);
        }
      }
      await getPaginatedProducts(
        rowsPerPage,
        evaluateKeys[page],
        true,
        page,
        tempFiltersReq
      );
    });
  };

  React.useEffect(() => {
    fetchInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const tempSelection = _.clone(allPageItemSelected);
    if (!(page >= 0 && page < tempSelection.length)) {
      setAllPageItemSelected((prevState) => {
        const newState = [...prevState];
        newState[page] = false;
        return newState;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  React.useEffect(() => {
    if (_.isEmpty(updatedItems)) {
      setDeletedImages([]);
    }
  }, [updatedItems]);

  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElFilter(event.currentTarget);
    setOpenFilter((previousOpen) => !previousOpen);
  };

  const handleFilterClose = () => {
    setAnchorElFilter(null);
    setOpenFilter(false);
  };

  const handleConfirmPageChange = async () => {
    setUpdatedItems([]);
    setSelectedProducts([]);
    setIsAllSelected(false);
    setPage(NEW_PAGE);
    setShowNavigationWarning(false);
    await getPaginatedProducts(
      rowsPerPage,
      evaluateKeys[NEW_PAGE],
      true,
      NEW_PAGE,
      selectedFilters
    );
    NEW_PAGE = 1;
  };

  const handleChangePage = async (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    NEW_PAGE = newPage;
    if (!_.isEmpty(updatedItems)) {
      setShowNavigationWarning(true);
    } else {
      setPage(newPage);
      await getPaginatedProducts(
        rowsPerPage,
        evaluateKeys[newPage],
        true,
        newPage,
        selectedFilters
      );
    }
  };

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (updatedItems?.length > 0) {
      setShowWarning(true);
      setActionName("ROWS");
      const rows = parseInt(event.target.value, 10);
      setNoOfRows(rows);
    } else {
      const rows = parseInt(event.target.value, 10);
      setRowsPerPage(rows);
      setPage(0);
      getPaginatedProducts(rows, evaluateKeys[0], true, 0, selectedFilters);
    }
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    handleChangePage(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    handleChangePage(event, page + 1);
  };

  const updatePaginatedRecords = (newItem: any, selectedItem: any) => {
    let tempProducts = _.cloneDeep(paginatedProducts);
    tempProducts = tempProducts.map((tp) => {
      if (tp.RecordId === selectedItem.RecordId) {
        return {
          ...selectedItem,
          ...newItem,
          LastUpdatedBy: account?.name || "",
          LastUpdatedDateTime: format(new Date(), "MMM dd, yyyy hh:mm aa"),
        };
      }
      return tp;
    });
    setPaginatedProducts(_.cloneDeep(tempProducts));

    let tempItems = _.clone(updatedItems);
    const tempSelectedProducts = _.clone(selectedProducts);

    const tempIndex = tempSelectedProducts.indexOf(selectedItem.RecordId);
    if (tempIndex === -1) {
      tempSelectedProducts.push(selectedItem.RecordId);
    }
    setSelectedProducts(tempSelectedProducts);

    const isExist = _.find(tempItems, ["RecordId", newItem?.RecordId]) || null;
    if (_.isEmpty(tempItems) || !isExist) {
      tempItems.push(newItem);
    } else {
      tempItems = tempItems.map((t: any) => {
        if (t.RecordId === newItem.RecordId) {
          const temp = {
            ...t,
            ...newItem,
          };
          return temp;
        }
        return t;
      });
    }
    setUpdatedItems(tempItems);
  };

  const onProductTitleChange = (
    e: any,
    selectedItem: any,
    productTitle: any = null
  ) => {
    let updatedItem: any = {
      Brand: selectedItem?.Brand || "",
      UPCSortKey: selectedItem?.UPCSortKey || "",
      RecordId: selectedItem?.RecordId || "",
      RecordStatus: selectedItem?.RecordStatus,
    };
    if (selectedItem?.RecordId) {
      if (_.isEmpty(selectedItem.ProductTitle)) {
        updatedItem = {
          ...updatedItem,
          ProductTitle: [
            {
              Sdesc: e.target.value,
              Selected: true,
              Source: "User Input",
            },
          ],
        };
      } else {
        let tempSD = _.clone(selectedItem.ProductTitle);
        if (productTitle) {
          tempSD = tempSD.map((ts: any) => {
            if (ts.Source === productTitle.Source) {
              ts["Selected"] = true;
            } else {
              ts["Selected"] = false;
            }
            return ts;
          });
        } else {
          const findTitle = _.find(tempSD, "Selected") || null;
          if (findTitle) {
            if (findTitle?.Source.includes("User Input")) {
              tempSD = tempSD.map((ts: any) => {
                if (ts.Source === findTitle?.Source) {
                  return {
                    ...ts,
                    Sdesc: e.target.value,
                  };
                }
                return ts;
              });
            } else {
              const tempTitle = {
                Sdesc: e.target.value,
                Selected: true,
                Source: `${findTitle?.Source}-User Input`,
              };
              tempSD = tempSD.map((ts: any) => {
                ts["Selected"] = false;
                return ts;
              });
              tempSD = [tempTitle].concat(tempSD);
            }
          }
        }

        updatedItem = {
          ...updatedItem,
          ProductTitle: _.uniqBy(tempSD, "Source"),
        };
      }
      updatePaginatedRecords(updatedItem, selectedItem);
    }
  };

  const onLongDescChange = (
    e: any,
    selectedItem: any,
    longDesc: any = null
  ) => {
    let updatedItem: any = {
      Brand: selectedItem?.Brand || "",
      UPCSortKey: selectedItem?.UPCSortKey || "",
      RecordId: selectedItem?.RecordId || "",
      RecordStatus: selectedItem?.RecordStatus,
    };
    if (selectedItem?.RecordId) {
      if (_.isEmpty(selectedItem.LongDescription)) {
        updatedItem = {
          ...updatedItem,
          LongDescription: [
            {
              Ldesc: e.target.value,
              Selected: true,
              Source: "User Input",
            },
          ],
        };
      } else {
        let tempLD = _.clone(selectedItem.LongDescription);
        if (longDesc) {
          tempLD = tempLD.map((tl: any) => {
            if (tl.Source === longDesc.Source) {
              tl["Selected"] = true;
            } else {
              tl["Selected"] = false;
            }
            return tl;
          });
        } else {
          const findLongDesc = _.find(tempLD, "Selected") || null;
          if (findLongDesc) {
            if (findLongDesc?.Source.includes("User Input")) {
              tempLD = tempLD.map((tl: any) => {
                if (tl.Source === findLongDesc?.Source) {
                  return {
                    ...tl,
                    Ldesc: e.target.value,
                  };
                }
                return tl;
              });
            } else {
              const tempLongDesc = {
                Ldesc: e.target.value,
                Selected: true,
                Source: `${findLongDesc?.Source}-User Input`,
              };
              tempLD = tempLD.map((tl: any) => {
                tl["Selected"] = false;
                return tl;
              });
              tempLD = [tempLongDesc].concat(tempLD);
            }
          }
        }

        updatedItem = {
          ...updatedItem,
          LongDescription: _.uniqBy(tempLD, "Source"),
        };
      }
      updatePaginatedRecords(updatedItem, selectedItem);
    }
  };

  const onIngChange = (e: any, selectedItem: any, ing: any = null) => {
    let updatedItem: any = {
      Brand: selectedItem?.Brand || "",
      UPCSortKey: selectedItem?.UPCSortKey || "",
      RecordId: selectedItem?.RecordId || "",
      RecordStatus: selectedItem?.RecordStatus,
    };
    if (selectedItem?.RecordId) {
      if (_.isEmpty(selectedItem.Ingredients)) {
        updatedItem = {
          ...updatedItem,
          Ingredients: [
            {
              Ingredients: e.target.value,
              Selected: true,
              Source: "User Input",
            },
          ],
        };
      } else {
        let tempIng = _.clone(selectedItem.Ingredients);
        if (ing) {
          tempIng = tempIng.map((ti: any) => {
            if (ti.Source === ing.Source) {
              ti["Selected"] = true;
            } else {
              ti["Selected"] = false;
            }
            return ti;
          });
        } else {
          const findIng = _.find(tempIng, "Selected") || null;
          if (findIng) {
            if (findIng?.Source.includes("User Input")) {
              tempIng = tempIng.map((ti: any) => {
                if (ti.Source === findIng?.Source) {
                  return {
                    ...ti,
                    Ingredients: e.target.value,
                  };
                }
                return ti;
              });
            } else {
              const tempIngredients = {
                Ingredients: e.target.value,
                Selected: true,
                Source: `${findIng?.Source}-User Input`,
              };
              tempIng = tempIng.map((ti: any) => {
                ti["Selected"] = false;
                return ti;
              });
              tempIng = [tempIngredients].concat(tempIng);
            }
          }
        }

        updatedItem = {
          ...updatedItem,
          Ingredients: _.uniqBy(tempIng, "Source"),
        };
      }
      updatePaginatedRecords(updatedItem, selectedItem);
    }
  };

  const onNoteChange = (val: string, selectedItem: any) => {
    if (_.isEmpty(val.trim()) && _.isEmpty(selectedItem?.Comments)) {
      return;
    }
    let updatedItem: any = {
      Brand: selectedItem?.Brand || "",
      UPCSortKey: selectedItem?.UPCSortKey || "",
      RecordId: selectedItem?.RecordId || "",
      RecordStatus: selectedItem?.RecordStatus,
      Comments: val || "",
    };
    if (selectedItem?.RecordId) {
      updatePaginatedRecords(updatedItem, selectedItem);
    }
  };

  const onStatusUpdate = (selectedItem: any, val: string) => {
    let updatedItem: any = {
      Brand: selectedItem?.Brand || "",
      UPCSortKey: selectedItem?.UPCSortKey || "",
      RecordId: selectedItem?.RecordId || "",
    };
    if (selectedItem?.RecordId) {
      updatedItem = {
        ...updatedItem,
        RecordStatus: val,
      };
      updatePaginatedRecords(updatedItem, selectedItem);
    }
  };

  const onRowSelection = (e: any, selectedItem: any) => {
    if (selectedItem?.UPC) {
      const tempSelectedItems = _.clone(selectedProducts);
      if (e.target.checked) {
        tempSelectedItems.push(selectedItem.RecordId);
      } else {
        let isExist = false;
        if (!_.isEmpty(updatedItems)) {
          const tempItems = _.clone(updatedItems);
          isExist =
            _.find(tempItems, ["RecordId", selectedItem?.RecordId]) || false;
        }
        if (isExist) {
          setModifiedItem(selectedItem);
          setTimeout(() => {
            setShowModificationWarning(true);
          }, 200);
        } else {
          const tempIndex = tempSelectedItems.indexOf(selectedItem.RecordId);
          tempSelectedItems.splice(tempIndex, 1);
        }
      }
      setSelectedProducts(tempSelectedItems);
      setAllPageItemSelected((prevState) => {
        const newState = [...prevState];
        newState[page] =
          tempSelectedItems.length === rowsPerPage ? true : false;
        return newState;
      });
    }
  };

  const onSaveChanges = async (recordID = null) => {
    try {
      setRecordDetailsLoading(true);
      let tempUpdatedItems: any[] = [];
      if (_.isEmpty(updatedItems)) {
        if (allPageItemSelected[page]) {
          paginatedProducts.forEach((pr: any) => {
            const updatedItem: any = {
              Brand: pr?.Brand || "",
              RecordId: pr?.RecordId || "",
              UPCSortKey: pr?.UPCSortKey || "",
              RecordStatus: "Approved",
            };
            tempUpdatedItems.push(updatedItem);
          });
        } else {
          paginatedProducts.forEach((pr: any) => {
            if (selectedProducts.indexOf(pr.RecordId) > -1) {
              const updatedItem: any = {
                Brand: pr?.Brand || "",
                RecordId: pr?.RecordId || "",
                UPCSortKey: pr?.UPCSortKey || "",
                RecordStatus: "Approved",
              };
              tempUpdatedItems.push(updatedItem);
            }
          });
        }
      } else {
        tempUpdatedItems = _.cloneDeep(updatedItems);
        if (recordID) {
          const filteredItems: any[] = [];
          tempUpdatedItems.map((tmp: any) => {
            if (tmp.RecordId === recordID) {
              if (tmp?.RecordStatus === "Ready for Review") {
                const findRecord = _.find(products, ["RecordId", recordID]);
                let isUpdated = false;
                if (findRecord) {
                  if (
                    !_.isUndefined(tmp?.ProductTitle) ||
                    !_.isUndefined(tmp?.LongDescription) ||
                    !_.isUndefined(tmp?.Ingredients) ||
                    !_.isUndefined(tmp?.Comments) ||
                    !_.isUndefined(tmp?.Images)
                  ) {
                    isUpdated = true;
                  }

                  if (
                    isUpdated &&
                    findRecord.RecordStatus === "Ready for Review"
                  ) {
                    tmp["RecordStatus"] = "In Review";
                  }
                }
              }
              filteredItems.push(tmp);
            }
            return tmp;
          });
          tempUpdatedItems = _.cloneDeep(filteredItems);
        }
      }

      if (_.isEmpty(tempUpdatedItems)) {
        return;
      }

      const reqData: any = {
        LastUpdatedBy: account?.name || "",
        updatefields: tempUpdatedItems,
      };
      if (!_.isEmpty(deletedImages)) {
        reqData["deletedImages"] = deletedImages;
      }
      const updateRes = await updateProducts(reqData);
      setUpdatedItems([]);
      setSelectedProducts([]);
      setIsAllSelected(false);
      setAllPageItemSelected([false]);
      if (updateRes?.statusCode === 200) {
        const updatedRecord = _.get(updateRes, "body.Record", null) || null;
        const res = paginatedProducts.map((pr: any) => {
          if (
            !_.isEmpty(updatedRecord) &&
            pr.RecordId === updatedRecord?.RecordId
          ) {
            return updatedRecord;
          }
          return pr;
        });
        setPaginatedProducts(res);
        setProducts(_.cloneDeep(res));
        setRecordDetailsLoading(false);
      } else {
        setRecordDetailsLoading(false);
        await getPaginatedProducts(
          rowsPerPage,
          evaluateKeys[page],
          true,
          page,
          selectedFilters
        );
      }
    } catch (error) {
      console.error("[updateProducts]: ", error);
      setIsLoading(false);
      setRecordDetailsLoading(false);
    } finally {
      setIsLoading(false);
      setRecordDetailsLoading(false);
    }
  };

  const onSearchChange = async (e: any) => {
    if (e.target.value && !/^\d+$/.test(e.target.value)) {
      e.preventDefault();
      return;
    }
    setSearchText(e.target.value);
    if (e.target.value.length === 14 && !Boolean(validateUPC(e.target.value))) {
      try {
        setIsLoading(true);
        setAnchorElFilter(null);
        setOpenFilter(false);
        setSelectedFiles([]);
        setSelectedCategories([]);
        setSelectedBrands([]);
        setSelectedSources([]);
        setSelectedStatus([]);
        setSearchedFilters({
          FileName: "",
          Category: "",
          Brand: "",
        });
        setBrandTerm("");
        setFilteredBrands(filters["Brand"] || []);
        setSelectedFilters({});
        setAllPageItemSelected([false]);
        setIsAllSelected(false);
        setSelectedProducts([]);
        const items: any = await getProductsByUPC(e.target.value);
        setPage(0);
        if (items?.statusCode === 200) {
          if (!_.isEmpty(items?.body)) {
            setTotalProducts(items?.body?.totalRecords);
            setProducts(_.cloneDeep(items?.body?.Items));
            setPaginatedProducts(_.cloneDeep(items?.body?.Items));
          }
        } else {
          setTotalProducts(0);
          setProducts([]);
          setPaginatedProducts([]);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("[FetchProductByUPC]: ", error);
        setIsLoading(false);
      }
    } else {
      if (_.isEmpty(e.target.value)) {
        setIsLoading(true);
        await fetchInitialData();
      }
    }
  };

  const onFileFilterChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    const tempFiles = typeof value === "string" ? value.split(",") : value;
    setSelectedFiles(tempFiles);
  };

  const onCategoryFilterChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    const tempCategories = typeof value === "string" ? value.split(",") : value;
    setSelectedCategories(tempCategories);
  };

  const onBrandFilterChange = (value: any) => {
    const tempBrands = _.clone(selectedBrands);
    if (_.isEmpty(tempBrands)) {
      tempBrands.push(value);
    } else {
      const currentIndex = tempBrands.indexOf(value);
      if (currentIndex === -1) {
        tempBrands.push(value);
      } else {
        tempBrands.splice(currentIndex, 1);
      }
    }
    setSelectedBrands(tempBrands);
  };

  const onSourceFilterChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    const tempSources = typeof value === "string" ? value.split(",") : value;
    setSelectedSources(tempSources);
  };

  const onStatusFilterChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    const tempStatus = typeof value === "string" ? value.split(",") : value;
    setSelectedStatus(tempStatus);
  };

  const onApplyFilter = () => {
    setAnchorElFilter(null);
    setOpenFilter(false);
    setSearchText("");
    if (updatedItems?.length > 0) {
      setShowWarning(true);
      setActionName("FILTER");
    } else {
      setIsFilterApplied(true);
      setIsLoading(true);
      const tempSelectedFilters: any = {};
      if (!_.isEmpty(selectedStatus)) {
        tempSelectedFilters["RecordStatus"] = selectedStatus;
      }
      if (!_.isEmpty(selectedFiles)) {
        tempSelectedFilters["FileName"] = selectedFiles;
      }
      if (!_.isEmpty(selectedCategories)) {
        tempSelectedFilters["Category"] = selectedCategories;
      }
      if (!_.isEmpty(selectedBrands)) {
        tempSelectedFilters["Brand"] = selectedBrands;
      }
      if (!_.isEmpty(selectedSources)) {
        tempSelectedFilters["SourceSystem"] = selectedSources;
      }
      if (!_.isEmpty(selectedFilters?.ProductTitle)) {
        tempSelectedFilters["ProductTitle"] = _.clone(
          selectedFilters?.ProductTitle
        );
      }
      if (!_.isEmpty(selectedFilters?.LongDescription)) {
        tempSelectedFilters["LongDescription"] = _.clone(
          selectedFilters?.LongDescription
        );
      }
      if (!_.isEmpty(selectedFilters?.Ingredients)) {
        tempSelectedFilters["Ingredients"] = _.clone(
          selectedFilters?.Ingredients
        );
      }
      setSelectedFilters(tempSelectedFilters);
      setTimeout(() => {
        setPage(0);
        getPaginatedProducts(
          rowsPerPage,
          evaluateKeys[0],
          true,
          0,
          tempSelectedFilters
        );
      }, 500);
    }
  };

  const onClearFileFilter = () => {
    const tempFilters = _.clone(selectedFilters);
    delete tempFilters["FileName"];
    setSelectedFiles([]);
    setSelectedFilters(tempFilters);
    if (_.isEmpty(tempFilters)) {
      setIsFilterApplied(false);
    }
    getPaginatedProducts(
      rowsPerPage,
      evaluateKeys[page],
      true,
      page,
      tempFilters
    );
  };

  const onClearCategoryFilter = () => {
    const tempFilters = _.clone(selectedFilters);
    delete tempFilters["Category"];
    setSelectedCategories([]);
    setSelectedFilters(tempFilters);
    if (_.isEmpty(tempFilters)) {
      setIsFilterApplied(false);
    }
    getPaginatedProducts(
      rowsPerPage,
      evaluateKeys[page],
      true,
      page,
      tempFilters
    );
  };

  const onClearBrandFilter = () => {
    const tempFilters = _.clone(selectedFilters);
    delete tempFilters["Brand"];
    setSelectedBrands([]);
    setSelectedFilters(tempFilters);
    setBrandTerm("");
    setFilteredBrands(filters["Brand"] || []);
    if (_.isEmpty(tempFilters)) {
      setIsFilterApplied(false);
    }
    getPaginatedProducts(
      rowsPerPage,
      evaluateKeys[page],
      true,
      page,
      tempFilters
    );
  };

  const onClearSourceFilter = () => {
    const tempFilters = _.clone(selectedFilters);
    delete tempFilters["SourceSystem"];
    setSelectedSources([]);
    setSelectedFilters(tempFilters);
    if (_.isEmpty(tempFilters)) {
      setIsFilterApplied(false);
    }
    getPaginatedProducts(
      rowsPerPage,
      evaluateKeys[page],
      true,
      page,
      tempFilters
    );
  };

  const onClearStatusFilter = () => {
    const tempFilters = _.clone(selectedFilters);
    delete tempFilters["RecordStatus"];
    setSelectedStatus([]);
    setSelectedFilters(tempFilters);
    if (_.isEmpty(tempFilters)) {
      setIsFilterApplied(false);
    }
    getPaginatedProducts(
      rowsPerPage,
      evaluateKeys[page],
      true,
      page,
      tempFilters
    );
  };

  const onClearAllFilter = () => {
    setAnchorElFilter(null);
    setOpenFilter(false);
    setSelectedFiles([]);
    setSelectedCategories([]);
    setSelectedBrands([]);
    setSelectedStatus([]);
    setSelectedSources([]);
    setSearchedFilters({
      FileName: "",
      Category: "",
      Brand: "",
    });
    setBrandTerm("");
    setSearchText("");
    setFilteredBrands(filters["Brand"] || []);
    setSelectedFilters({});
    if (isFilterApplied) {
      setIsFilterApplied(false);
      setPage(0);
      getPaginatedProducts(rowsPerPage, evaluateKeys[0], true, 0, {});
    }
  };

  const debouncedSearch = _.debounce(
    async (term: string, key: string) => {
      await fetchFilters({
        ...searchedFilters,
        [key]: term,
      });
    },
    500,
    { leading: false, trailing: true }
  );

  const onFilterSearch = async (term: string, key: string) => {
    setSearchedFilters({
      ...searchedFilters,
      [key]: term,
    });
    if (term.length > 2 || term === "") {
      debouncedSearch(term, key);
    }
  };

  const onBrandSearch = (term: string) => {
    setSearchedFilters({
      ...searchedFilters,
      Brand: term,
    });
    setBrandTerm(term);
    const tempBrands = _.clone(filters["Brand"] || []);
    const result = tempBrands.filter((b: string) =>
      b.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredBrands(result);
  };

  const onConfirmAllSelection = () => {
    const tempSelectedItems: string[] = [];
    paginatedProducts.forEach((pr: any) => {
      tempSelectedItems.push(pr.RecordId);
    });

    setUpdatedItems([]);
    setPaginatedProducts(_.cloneDeep(products));

    setSelectedProducts(tempSelectedItems);
    setAllPageItemSelected((prevState) => {
      const newState = [...prevState];
      newState[page] = true;
      return newState;
    });
    setShowSelectionWarning(false);
  };

  const onAllSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      if (!_.isEmpty(updatedItems)) {
        setShowSelectionWarning(true);
      } else {
        onConfirmAllSelection();
      }
    } else {
      setAllPageItemSelected((prevState) => {
        const newState = [...prevState];
        newState[page] = event.target.checked;
        return newState;
      });
      setIsAllSelected(false);
      setSelectedProducts([]);
      setUpdatedItems([]);
    }
  };

  const onConfirmApproval = async () => {
    try {
      const tempFilters = _.clone(selectedFilters);
      delete tempFilters["RecordStatus"];
      setShowApprovalWarning(false);
      setIsLoading(true);
      const reqData: any = {
        LastUpdatedBy: account?.name || "",
        LastApprovedBy: account?.name || "",
        massapprovalfields: {
          filters: tempFilters,
        },
      };
      await updateProducts(reqData);
      setUpdatedItems([]);
      setSelectedProducts([]);
      setAllPageItemSelected([false]);
      setIsAllSelected(false);
      setShowMassApprovalPending(true);
      ProductStore.setMassApproval(true);
      setIsLoading(false);
    } catch (error) {
      console.error("[onConfirmApproval]: ", error);
      setIsLoading(false);
    }
  };

  const onDeniedApproval = () => {
    const tempSelected: string[] = [];
    updatedItems.forEach((u: any) => {
      tempSelected.push(u.RecordId);
    });
    setSelectedProducts(tempSelected);
    setAllPageItemSelected((prevState) => {
      const newState = [...prevState];
      newState[page] = tempSelected.length === rowsPerPage ? true : false;
      return newState;
    });
    setShowApprovalWarning(false);
  };

  const onSelectAllClick = () => {
    if (!_.isEmpty(updatedItems)) {
      setShowApprovalWarning(true);
    } else {
      setIsAllSelected(true);
    }
  };

  const handleImageUpload = async (
    images: any[],
    selectedItem: any,
    deletedImages: string[] = []
  ) => {
    try {
      setIsFetching(true);
      const resultImages: any[] = [];
      if (images?.length > 0) {
        const uploadImage = async (
          imageName: string,
          newImage: any,
          type: string
        ) => {
          // 1. Fetch S3 Presigned URL
          try {
            const presignedURLRes = await getS3PresignedURL({
              uploadedBy: account?.name || "",
              filePath: `Images/${selectedItem.UPC}/${imageName}`,
              IsImage: "1",
            });
            if (presignedURLRes?.statusCode === 200) {
              // 2. Upload file using Presigned URL
              try {
                const uploadURL = presignedURLRes?.body?.URL;
                await axios.put(uploadURL, newImage, {
                  headers: {
                    "Content-Type": type,
                  },
                });
                return true;
              } catch (error) {
                console.error("There was an error uploading file: ", error);
              }
            }
          } catch (error) {
            console.error("[uploadImage]: ", error);
          }
        };

        const uploadFiles = async () => {
          for (const imageData of images) {
            if (_.has(imageData, "file")) {
              const image = imageData?.file;
              const fileExtension = "." + image.name.split(/\.(?=[^\.]+$)/)[1];
              const prefix = image.name.split(/\.(?=[^\.]+$)/)[0];
              const imageName = `${prefix}_User_Input_${format(
                new Date(),
                "MM-dd-yyyy-HH-mm-ss"
              )}${fileExtension}`;
              var blob = image.slice(0, image.size, image.type);
              var newImage = new File([blob], imageName, { type: image.type });
              await uploadImage(imageName, newImage, image.type);
              resultImages.push({
                Image: `Images/${selectedItem.UPC}/${imageName}`,
                Primary: imageData?.Primary || false,
                Selected: imageData?.Selected || true,
                Source: imageData?.Source || "User Input",
                ImageType: imageData?.ImageType || "O",
              });
            } else {
              resultImages.push(imageData);
            }
          }
        };
        await uploadFiles();
      }
      let updatedItem: any = {
        Brand: selectedItem?.Brand || "",
        UPCSortKey: selectedItem?.UPCSortKey || "",
        RecordId: selectedItem?.RecordId || "",
        RecordStatus: selectedItem?.RecordStatus,
        Images: resultImages,
      };
      if (selectedItem?.RecordId) {
        setDeletedImages(deletedImages);
        updatePaginatedRecords(updatedItem, selectedItem);
      }
      setIsFetching(false);
    } catch (error) {
      console.error("[handleImageUpload]: ", error);
      setIsFetching(false);
    }
  };

  const handleConfirmProcess = () => {
    setUpdatedItems([]);
    setSelectedProducts([]);
    setAllPageItemSelected([false]);
    setIsAllSelected(false);
    setShowWarning(false);
    switch (actionName) {
      case "FILTER":
        setIsFilterApplied(true);
        setIsLoading(true);
        const tempSelectedFilters = _.clone(selectedFilters);
        if (!_.isEmpty(selectedStatus)) {
          tempSelectedFilters["RecordStatus"] = selectedStatus;
        }
        if (!_.isEmpty(selectedFiles)) {
          tempSelectedFilters["FileName"] = selectedFiles;
        }
        if (!_.isEmpty(selectedCategories)) {
          tempSelectedFilters["Category"] = selectedCategories;
        }
        if (!_.isEmpty(selectedBrands)) {
          tempSelectedFilters["Brand"] = selectedBrands;
        }
        setSelectedFilters(tempSelectedFilters);
        setTimeout(() => {
          getPaginatedProducts(
            rowsPerPage,
            evaluateKeys[page],
            true,
            page,
            tempSelectedFilters
          );
        }, 500);
        break;
      case "ROWS":
        setRowsPerPage(noOfRows);
        setPage(0);
        getPaginatedProducts(
          noOfRows,
          evaluateKeys[0],
          true,
          0,
          selectedFilters
        );
        break;

      default:
        break;
    }
  };

  const handleCarouselClick = (
    images: any,
    upc: string,
    imageIndex: number
  ) => {
    setCarouselImages(images || []);
    setImageCarouselUPC(upc || "");
    setSelectedCarouselImage(imageIndex);
    setTimeout(() => {
      setOpenImageCarousel(true);
    }, 500);
  };

  const getImageType = (type: "F" | "B" | "N" | "O") => {
    switch (type) {
      case "F":
        return "Front Side";
      case "B":
        return "Ingredients";
      case "N":
        return "Nutrition facts";
      case "O":
        return "Additional";

      default:
        return "";
    }
  };

  const validateUPC = (value: string) => {
    if (!value) {
      return "";
    }
    const pattern = /^\d{14}$/;
    return pattern.test(value) ? "" : "Invalid UPC format (14 digits only)";
  };

  const handleModificationConfirmProcess = () => {
    // 1. Revert Changes
    const originalItem =
      _.find(products, ["RecordId", modifiedItem?.RecordId]) || null;
    if (originalItem) {
      const tempProducts = _.cloneDeep(paginatedProducts);
      const tempProductIndex = _.findIndex(tempProducts, {
        RecordId: modifiedItem?.RecordId,
      });

      tempProducts.splice(tempProductIndex, 1, originalItem);
      setPaginatedProducts(_.cloneDeep(tempProducts));
      // 2. Remove item from updated entries
      const tempUpdatedItems = _.clone(updatedItems);
      const tempUpdatedIndex = _.findIndex(tempUpdatedItems, {
        RecordId: modifiedItem?.RecordId,
      });
      tempUpdatedItems.splice(tempUpdatedIndex, 1);
      setUpdatedItems(tempUpdatedItems);
      // 3. Remove selected item
      const tempSelectedItems = _.clone(selectedProducts);
      const tempSelectedIndex = tempSelectedItems.indexOf(
        modifiedItem.RecordId
      );
      tempSelectedItems.splice(tempSelectedIndex, 1);
      setSelectedProducts(tempSelectedItems);
      setAllPageItemSelected((prevState) => {
        const newState = [...prevState];
        newState[page] =
          tempSelectedItems.length === rowsPerPage ? true : false;
        return newState;
      });
    }
    setShowModificationWarning(false);
  };

  const onSearchClear = async () => {
    setIsLoading(true);
    setSearchText("");
    await fetchInitialData();
  };

  return (
    <Box sx={PRODUCT_WRAPPER}>
      <Stack sx={PRODUCT_FILTER_WRAPPER}>
        <Stack direction={"row"} alignItems={"center"} spacing={2}>
          <BootstrapTooltip
            title={"Select all the record on this page"}
            placement="right"
          >
            <Checkbox
              sx={{ padding: 0 }}
              checked={allPageItemSelected[page] || false}
              icon={
                <CheckBoxOutlineBlank
                  sx={{ color: "#6F7784", borderRadius: "4px", opacity: 0.6 }}
                />
              }
              checkedIcon={
                <CheckBox sx={{ color: "#077942", borderRadius: "4px" }} />
              }
              onChange={onAllSelection}
            />
          </BootstrapTooltip>
          <TextField
            sx={{
              ...INPUT_WRAPPER,
              border: Boolean(validateUPC(searchText))
                ? "1px solid #BA0C2F"
                : "1px solid rgba(240, 247, 236, 0.2)",
            }}
            autoComplete={"off"}
            type={"text"}
            variant="standard"
            placeholder="Search by UPC"
            error={Boolean(validateUPC(searchText))}
            value={searchText}
            onChange={onSearchChange}
            inputProps={{ maxLength: 14, pattern: "[0-9]+" }}
            InputProps={{
              disableUnderline: true,
              sx: BASE_INPUT,
              startAdornment: (
                <InputAdornment position="start">
                  <Search
                    sx={{
                      color: Boolean(validateUPC(searchText))
                        ? "#BA0C2F"
                        : "#6F7784",
                    }}
                    fontSize={"small"}
                  />
                </InputAdornment>
              ),
              endAdornment: searchText && (
                <InputAdornment position="end" onClick={onSearchClear}>
                  <Clear
                    sx={{ color: "#6F7784", cursor: "pointer" }}
                    fontSize={"small"}
                  />
                </InputAdornment>
              ),
            }}
          />
          <Divider
            orientation="vertical"
            variant="middle"
            sx={{
              background: "rgba(15, 61, 97, 0.08)",
              height: 36,
            }}
          />
          {!_.isEmpty(selectedFilters["FileName"]) && isFilterApplied && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={1}
              sx={ITEM_CARD_FILTER_SELECTION}
            >
              <Typography sx={ITEM_CARD_FILTER_COUNT}>
                {selectedFilters["FileName"].length}
              </Typography>
              <Typography sx={ITEM_CARD_FILTER_TEXT}>By File Name</Typography>
              <IconButton size="small" onClick={onClearFileFilter}>
                <Close
                  fontSize="small"
                  sx={{ color: "rgba(111, 119, 132, 0.54)" }}
                />
              </IconButton>
            </Stack>
          )}
          {!_.isEmpty(selectedFilters["Category"]) && isFilterApplied && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={1}
              sx={ITEM_CARD_FILTER_SELECTION}
            >
              <Typography sx={ITEM_CARD_FILTER_COUNT}>
                {selectedFilters["Category"].length}
              </Typography>
              <Typography sx={ITEM_CARD_FILTER_TEXT}>By Category</Typography>
              <IconButton size="small" onClick={onClearCategoryFilter}>
                <Close
                  fontSize="small"
                  sx={{ color: "rgba(111, 119, 132, 0.54)" }}
                />
              </IconButton>
            </Stack>
          )}
          {!_.isEmpty(selectedFilters["Brand"]) && isFilterApplied && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={1}
              sx={ITEM_CARD_FILTER_SELECTION}
            >
              <Typography sx={ITEM_CARD_FILTER_COUNT}>
                {selectedFilters["Brand"].length}
              </Typography>
              <Typography sx={ITEM_CARD_FILTER_TEXT}>By Brand</Typography>
              <IconButton size="small" onClick={onClearBrandFilter}>
                <Close
                  fontSize="small"
                  sx={{ color: "rgba(111, 119, 132, 0.54)" }}
                />
              </IconButton>
            </Stack>
          )}
          {!_.isEmpty(selectedFilters["SourceSystem"]) && isFilterApplied && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={1}
              sx={ITEM_CARD_FILTER_SELECTION}
            >
              <Typography sx={ITEM_CARD_FILTER_COUNT}>
                {selectedFilters["SourceSystem"].length}
              </Typography>
              <Typography sx={ITEM_CARD_FILTER_TEXT}>By Source</Typography>
              <IconButton size="small" onClick={onClearSourceFilter}>
                <Close
                  fontSize="small"
                  sx={{ color: "rgba(111, 119, 132, 0.54)" }}
                />
              </IconButton>
            </Stack>
          )}
          {!_.isEmpty(selectedFilters["RecordStatus"]) && isFilterApplied && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={1}
              sx={ITEM_CARD_FILTER_SELECTION}
            >
              <Typography sx={ITEM_CARD_FILTER_COUNT}>
                {selectedFilters["RecordStatus"].length}
              </Typography>
              <Typography sx={ITEM_CARD_FILTER_TEXT}>By Status</Typography>
              <IconButton size="small" onClick={onClearStatusFilter}>
                <Close
                  fontSize="small"
                  sx={{ color: "rgba(111, 119, 132, 0.54)" }}
                />
              </IconButton>
            </Stack>
          )}
          <Button
            variant="text"
            startIcon={<Add style={{ fontSize: 16 }} />}
            sx={FILTER_BUTTON}
            onClick={handleFilterClick}
          >
            Add Filter
          </Button>
          <Popover
            id={"filter-popover"}
            open={openFilter}
            anchorEl={anchorElFilter}
            onClose={handleFilterClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            elevation={0}
            PaperProps={{
              sx: ITEM_CARD_FILTER_PAPER,
            }}
          >
            <Stack spacing={2} minWidth={270}>
              <Typography sx={ITEM_CARD_FILTER_HEADER}>Add Filter</Typography>
              <Stack
                spacing={2}
                maxHeight={"calc(100vh - 300px)"}
                overflow={"auto"}
              >
                <FormControl variant="filled">
                  <InputLabel id="file-name-select" sx={ITEM_CARD_FILTER_LABEL}>
                    By File Name
                  </InputLabel>
                  <Select
                    labelId="file-name-select"
                    id="file-name-select-filled"
                    multiple
                    value={selectedFiles}
                    label={""}
                    onChange={onFileFilterChange}
                    MenuProps={{
                      autoFocus: false,
                      sx: ITEM_CARD_FILTER_MENU,
                    }}
                    sx={ITEM_CARD_FILTER_SELECT}
                    inputProps={{
                      sx: ITEM_CARD_SELECT_MENU,
                    }}
                    IconComponent={ExpandMore}
                    renderValue={(selected) =>
                      `${selected.length} file(s) selected`
                    }
                  >
                    <ListSubheader
                      disableGutters
                      sx={ITEM_CARD_FILTER_SUBHEADER}
                    >
                      <SearchInput
                        autoFocus
                        fullWidth
                        id="file-search-input"
                        placeholder="Search"
                        value={searchedFilters["FileName"]}
                        onChange={(e) =>
                          onFilterSearch(e.target.value, "FileName")
                        }
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    {isFilterLoading ? (
                      <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <CircularProgress sx={{ color: "#0F3D61" }} size={18} />
                      </Stack>
                    ) : (
                      filters["FileName"]?.map((fn: string, fIndex: number) => (
                        <MenuItem
                          key={`filename_${fIndex}`}
                          value={fn}
                          sx={ITEM_CARD_FILTER_MENUITEM_WRAPPER}
                        >
                          <ListItemText
                            primary={fn}
                            sx={ITEM_CARD_FILTER_MENUITEM}
                            disableTypography
                          />
                          <Checkbox
                            checked={selectedFiles.indexOf(fn) > -1}
                            checkedIcon={
                              <Check
                                sx={{ color: "#66A640" }}
                                fontSize="inherit"
                              />
                            }
                            icon={<></>}
                          />
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                <FormControl variant="filled">
                  <InputLabel id="category-select" sx={ITEM_CARD_FILTER_LABEL}>
                    By Category
                  </InputLabel>
                  <Select
                    labelId="category-select"
                    id="category-select-filled"
                    multiple
                    value={selectedCategories}
                    label={""}
                    onChange={onCategoryFilterChange}
                    MenuProps={{
                      autoFocus: false,
                      sx: ITEM_CARD_FILTER_MENU,
                    }}
                    sx={ITEM_CARD_FILTER_SELECT}
                    inputProps={{
                      sx: ITEM_CARD_SELECT_MENU,
                    }}
                    IconComponent={ExpandMore}
                    renderValue={(selected) =>
                      `${selected.length} category(s) selected`
                    }
                  >
                    <ListSubheader
                      disableGutters
                      sx={ITEM_CARD_FILTER_SUBHEADER}
                    >
                      <SearchInput
                        autoFocus
                        fullWidth
                        id="category-search-input"
                        placeholder="Search"
                        disabled={
                          filters["Category"]?.length === 1 &&
                          filters["Category"][0] === "Not Available"
                        }
                        value={searchedFilters["Category"]}
                        onChange={(e) =>
                          onFilterSearch(e.target.value, "Category")
                        }
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    {isFilterLoading ? (
                      <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <CircularProgress sx={{ color: "#0F3D61" }} size={18} />
                      </Stack>
                    ) : (
                      filters["Category"]?.map((c: string, cIndex: number) => (
                        <MenuItem
                          key={`category_${cIndex}`}
                          value={c}
                          sx={ITEM_CARD_FILTER_MENUITEM_WRAPPER}
                        >
                          <ListItemText
                            primary={c}
                            sx={ITEM_CARD_FILTER_MENUITEM}
                            disableTypography
                          />
                          <Checkbox
                            checked={selectedCategories.indexOf(c) > -1}
                            checkedIcon={
                              <Check
                                sx={{ color: "#66A640" }}
                                fontSize="inherit"
                              />
                            }
                            icon={<></>}
                          />
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                <FormControl variant="filled">
                  <InputLabel id="brand-select" sx={ITEM_CARD_FILTER_LABEL}>
                    By Brand
                  </InputLabel>
                  <Select
                    labelId="brand-select"
                    id="brand-select-filled"
                    multiple
                    value={selectedBrands}
                    label={""}
                    onChange={onBrandFilterChange}
                    MenuProps={{
                      autoFocus: false,
                      sx: {
                        "& .MuiMenu-paper": {
                          padding: "12px",
                          paddingTop: 0,
                          background: "#FFFFFF",
                          borderWidth: "0px 1px 1px 1px",
                          borderStyle: "solid",
                          borderColor: "rgba(213, 215, 220, 0.7)",
                          boxShadow: "0px 4px 8px rgba(15, 61, 97, 0.08)",
                          borderRadius: "0px 0px 4px 4px",
                          maxHeight: 204,
                          overflow: "hidden",
                        },
                        "& .MuiMenu-list": {
                          padding: 0,
                          maxWidth: 270,
                        },
                      },
                    }}
                    sx={ITEM_CARD_FILTER_SELECT}
                    inputProps={{
                      sx: ITEM_CARD_SELECT_MENU,
                    }}
                    IconComponent={ExpandMore}
                    renderValue={(selected) =>
                      `${selected.length} brand(s) selected`
                    }
                  >
                    <ListSubheader
                      disableGutters
                      sx={ITEM_CARD_FILTER_SUBHEADER}
                    >
                      <SearchInput
                        autoFocus
                        fullWidth
                        id="brand-search-input"
                        placeholder="Search"
                        value={brandTerm}
                        onChange={(e) =>
                          // onFilterSearch(e.target.value, "Brand")
                          onBrandSearch(e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    {isFilterLoading ? (
                      <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <CircularProgress sx={{ color: "#0F3D61" }} size={18} />
                      </Stack>
                    ) : (
                      <Virtuoso
                        style={{ height: 108 }}
                        data={filteredBrands}
                        totalCount={filteredBrands.length}
                        overscan={150}
                        computeItemKey={(
                          index: number,
                          item: any,
                          context: any
                        ) => `brand_${index}`}
                        itemContent={(index) => {
                          const b = filteredBrands[index];
                          return (
                            <MenuItem
                              key={`brand_${index}`}
                              value={b}
                              sx={ITEM_CARD_FILTER_MENUITEM_WRAPPER}
                              onClick={() => onBrandFilterChange(b)}
                            >
                              <ListItemText
                                primary={b}
                                sx={ITEM_CARD_FILTER_MENUITEM}
                                disableTypography
                              />
                              <Checkbox
                                checked={selectedBrands.indexOf(b) > -1}
                                checkedIcon={
                                  <Check
                                    sx={{ color: "#66A640" }}
                                    fontSize="inherit"
                                  />
                                }
                                icon={<></>}
                              />
                            </MenuItem>
                          );
                        }}
                      />
                    )}
                  </Select>
                </FormControl>
                <FormControl variant="filled">
                  <InputLabel id="source-select" sx={ITEM_CARD_FILTER_LABEL}>
                    By Source
                  </InputLabel>
                  <Select
                    labelId="source-select"
                    id="source-select-filled"
                    multiple
                    value={selectedSources}
                    label={""}
                    onChange={onSourceFilterChange}
                    MenuProps={{
                      autoFocus: false,
                      sx: {
                        ...ITEM_CARD_FILTER_MENU,
                        ...{
                          "& .MuiMenu-paper": {
                            padding: "12px",
                            background: "#FFFFFF",
                            borderWidth: "0px 1px 1px 1px",
                            borderStyle: "solid",
                            borderColor: "rgba(213, 215, 220, 0.7)",
                            boxShadow: "0px 4px 8px rgba(15, 61, 97, 0.08)",
                            borderRadius: "0px 0px 4px 4px",
                            maxHeight: 168,
                            overflow: "auto",
                          },
                        },
                      },
                    }}
                    sx={ITEM_CARD_FILTER_SELECT}
                    inputProps={{
                      sx: ITEM_CARD_SELECT_MENU,
                    }}
                    IconComponent={ExpandMore}
                    renderValue={(selected) =>
                      `${selected.length} source(s) selected`
                    }
                  >
                    {isFilterLoading ? (
                      <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <CircularProgress sx={{ color: "#0F3D61" }} size={18} />
                      </Stack>
                    ) : (
                      DATA_SOURCES.map((ds: string, dsIndex: number) => (
                        <MenuItem
                          key={`source_${dsIndex}`}
                          value={ds}
                          sx={ITEM_CARD_FILTER_MENUITEM_WRAPPER}
                        >
                          <ListItemText
                            primary={ds}
                            sx={ITEM_CARD_FILTER_MENUITEM}
                            disableTypography
                          />
                          <Checkbox
                            checked={selectedSources.indexOf(ds) > -1}
                            checkedIcon={
                              <Check
                                sx={{ color: "#66A640" }}
                                fontSize="inherit"
                              />
                            }
                            icon={<></>}
                          />
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                <FormControl variant="filled">
                  <InputLabel id="status-select" sx={ITEM_CARD_FILTER_LABEL}>
                    By Status
                  </InputLabel>
                  <Select
                    labelId="status-select"
                    id="status-select-filled"
                    multiple
                    value={selectedStatus}
                    label={""}
                    onChange={onStatusFilterChange}
                    MenuProps={{
                      autoFocus: false,
                      sx: {
                        ...ITEM_CARD_FILTER_MENU,
                        ...{
                          "& .MuiMenu-paper": {
                            padding: "12px",
                            background: "#FFFFFF",
                            borderWidth: "0px 1px 1px 1px",
                            borderStyle: "solid",
                            borderColor: "rgba(213, 215, 220, 0.7)",
                            boxShadow: "0px 4px 8px rgba(15, 61, 97, 0.08)",
                            borderRadius: "0px 0px 4px 4px",
                            maxHeight: 168,
                            overflow: "auto",
                          },
                        },
                      },
                    }}
                    sx={ITEM_CARD_FILTER_SELECT}
                    inputProps={{
                      sx: ITEM_CARD_SELECT_MENU,
                    }}
                    IconComponent={ExpandMore}
                    renderValue={(selected) =>
                      `${selected.length} status(s) selected`
                    }
                  >
                    {isFilterLoading ? (
                      <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <CircularProgress sx={{ color: "#0F3D61" }} size={18} />
                      </Stack>
                    ) : (
                      DATA_STATUS.map((ds: any, dsIndex: number) => (
                        <MenuItem
                          key={`status_${dsIndex}`}
                          value={ds}
                          sx={ITEM_CARD_FILTER_MENUITEM_WRAPPER}
                        >
                          <ListItemText
                            primary={ds}
                            sx={ITEM_CARD_FILTER_MENUITEM}
                            disableTypography
                          />
                          <Checkbox
                            checked={selectedStatus.indexOf(ds) > -1}
                            checkedIcon={
                              <Check
                                sx={{ color: "#66A640" }}
                                fontSize="inherit"
                              />
                            }
                            icon={<></>}
                          />
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                <Accordion
                  elevation={0}
                  disableGutters
                  sx={{
                    padding: "8px 12px 8px 16px",
                    background: "rgba(111, 119, 132, 0.04)",
                    borderRadius: "4px",
                    ":before": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMore sx={{ fontSize: 20, color: "#6F7784" }} />
                    }
                    aria-controls="filter-content"
                    id="filter-header"
                    sx={{
                      px: 0,
                      minHeight: 36,
                      "& .MuiAccordionSummary-content": { margin: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        lineHeight: "16px",
                        fontWeight: 500,
                        color: "#6F7784",
                      }}
                    >
                      Advanced Filters
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "8px 0" }}>
                    <Stack spacing={1}>
                      <RedditTextField
                        label="Title"
                        variant="filled"
                        value={selectedFilters?.ProductTitle || ""}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setSelectedFilters({
                            ...selectedFilters,
                            ProductTitle: event.target.value,
                          });
                        }}
                      />
                      <RedditTextField
                        label="Description"
                        variant="filled"
                        value={selectedFilters?.LongDescription || ""}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setSelectedFilters({
                            ...selectedFilters,
                            LongDescription: event.target.value,
                          });
                        }}
                      />
                      <RedditTextField
                        label="Ingredients"
                        variant="filled"
                        value={selectedFilters?.Ingredients || ""}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setSelectedFilters({
                            ...selectedFilters,
                            Ingredients: event.target.value,
                          });
                        }}
                      />
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              </Stack>
              <Stack
                direction={"row"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                spacing={1}
              >
                <Button
                  variant="contained"
                  sx={ITEM_CARD_FILTER_CLEAR_BTN}
                  onClick={onClearAllFilter}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  sx={ITEM_CARD_FILTER_APPLY_BTN}
                  onClick={onApplyFilter}
                >
                  Apply
                </Button>
              </Stack>
            </Stack>
          </Popover>
        </Stack>
        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          spacing={2}
        >
          {!_.isEmpty(selectedFilters) && isFilterApplied && (
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Divider
                orientation="vertical"
                variant="middle"
                sx={{
                  background: "rgba(15, 61, 97, 0.08)",
                  height: 36,
                }}
              />
              <Button
                variant="text"
                startIcon={<Close style={{ fontSize: 16 }} />}
                sx={FILTER_BUTTON}
                onClick={onClearAllFilter}
              >
                Clear All
              </Button>
            </Stack>
          )}
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Typography sx={SELECTION_TEXT}>
              {isAllSelected
                ? `All ${totalProducts} entries are selected`
                : allPageItemSelected[page]
                ? `All ${selectedProducts.length} entries on this page are selected.`
                : ""}
            </Typography>

            {allPageItemSelected[page] && isAllSelected && (
              <Button
                variant="text"
                sx={{ ...TEXT_BTN, color: "#B80530" }}
                onClick={() => {
                  setIsAllSelected(false);
                  setAllPageItemSelected([false]);
                  setSelectedProducts([]);
                  setUpdatedItems([]);
                }}
              >
                Clear Selection
              </Button>
            )}
            {allPageItemSelected[page] && !isAllSelected && (
              <Button
                variant="text"
                sx={TEXT_BTN}
                onClick={onSelectAllClick}
              >{`Select all ${totalProducts} entries`}</Button>
            )}
          </Stack>

          {(allPageItemSelected[page] || isAllSelected) && (
            <Button
              sx={SAVE_BTN}
              onClick={async () => {
                if (isAllSelected) {
                  await onConfirmApproval();
                } else {
                  await onSaveChanges(null);
                }
              }}
              startIcon={<Check />}
            >
              {isAllSelected
                ? "Approve All Entries"
                : "Approve Selected Entries"}
            </Button>
          )}
        </Stack>
      </Stack>
      <Stack flex={1}>
        {isFetching && <Spinner />}
        {isLoading ? (
          <Spinner />
        ) : paginatedProducts?.length > 0 ? (
          <>
            <Stack height={"calc(100vh - 200px)"} overflow={"auto"}>
              <Virtuoso
                style={{ height: "100%" }}
                data={paginatedProducts}
                totalCount={paginatedProducts.length}
                itemContent={(index) => {
                  const p = paginatedProducts[index];
                  return (
                    <Box mb={"12px"} key={`card_${p?.RecordId}_${index}`}>
                      <ItemCard
                        data={p}
                        isSelected={selectedProducts.indexOf(p.RecordId) > -1}
                        onProductTitleChange={onProductTitleChange}
                        onLongDescChange={onLongDescChange}
                        onIngChange={onIngChange}
                        onRowSelection={onRowSelection}
                        onUploadImages={handleImageUpload}
                        onNoteChange={onNoteChange}
                        onCarouselClick={handleCarouselClick}
                        openImageCarousel={openImageCarousel}
                        onStatusUpdate={onStatusUpdate}
                        onSaveChanges={onSaveChanges}
                        isPageAllSelected={allPageItemSelected[page]}
                        recordLoading={recordDetailsLoading}
                      />
                    </Box>
                  );
                }}
              />
            </Stack>
            <Stack sx={PAGINATION_WRAPPER}>
              <TablePagination
                component="div"
                count={totalProducts}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                SelectProps={{
                  sx: ITEM_CARD_SELECT_MENU,
                  MenuProps: {
                    MenuListProps: {
                      dense: true,
                      disablePadding: true,
                      sx: {
                        fontSize: 12,
                        lineHeight: "14px",
                        letterSpacing: "0.44px",
                        color: "#23242A",
                        padding: "6px 8px",
                      },
                    },
                  },
                }}
                labelDisplayedRows={function defaultLabelDisplayedRows({
                  from,
                  to,
                  count,
                }) {
                  return `Showing ${from} - ${to} entries of ${
                    count !== -1 ? `${count}` : `more than ${to}`
                  }`;
                }}
                rowsPerPageOptions={[
                  { label: "5 entries", value: 5 },
                  { label: "10 entries", value: 10 },
                  { label: "25 entries", value: 25 },
                  { label: "50 entries", value: 50 },
                  { label: "100 entries", value: 100 },
                ]}
                backIconButtonProps={{
                  sx: { height: 32, width: 32 },
                  onClick: handleBackButtonClick,
                }}
                nextIconButtonProps={{
                  sx: { height: 32, width: 32 },
                  onClick: handleNextButtonClick,
                }}
                sx={PAGINATION_CONTAINER}
              />
            </Stack>
          </>
        ) : (
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            flex={1}
          >
            <img src={NO_RECORDS} alt="No Records" height={204} width={204} />
          </Stack>
        )}
      </Stack>
      <Dialog
        open={showNavigationWarning}
        PaperProps={{
          sx: WARNING_DAILOG_WRAPPER,
        }}
        onClose={() => setShowNavigationWarning(false)}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack spacing={3}>
            <Stack spacing={3} sx={WARNING_DAILOG_HEADER}>
              <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                <WarningAmber style={{ fontSize: 18, color: "#B04509" }} />
                <Typography sx={WARNING_DAILOG_TITLE}>Warning</Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {updatedItems.length === 1
                      ? `You have modified one entry, by navigating to other pages
                    existing modified record will not be saved`
                      : `You have modified more than one entries, by navigating to other pages
                    existing modified records will not be saved`}
                  </Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {"Please click on save to incorporate changes"}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack spacing={2}>
              <Typography sx={WARNING_DAILOG_ACTION_TEXT}>
                Would you like to navigate?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_NO}
                  onClick={() => setShowNavigationWarning(false)}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_YES}
                  onClick={handleConfirmPageChange}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showSelectionWarning}
        PaperProps={{
          sx: WARNING_DAILOG_WRAPPER,
        }}
        onClose={() => setShowSelectionWarning(false)}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack spacing={3}>
            <Stack spacing={3} sx={WARNING_DAILOG_HEADER}>
              <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                <WarningAmber style={{ fontSize: 18, color: "#B04509" }} />
                <Typography sx={WARNING_DAILOG_TITLE}>Warning</Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {updatedItems.length === 1
                      ? `You have modified one entry. By selecting All Records you
                    will lose any changes made for the modified record.`
                      : `You have modified more than one entries. By selecting All Records you
                    will lose any changes made for the modified records.`}
                  </Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {"Please click on save to incorporate changes"}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack spacing={2}>
              <Typography sx={WARNING_DAILOG_ACTION_TEXT}>
                Would you like to select all records?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_NO}
                  onClick={() => setShowSelectionWarning(false)}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_YES}
                  onClick={onConfirmAllSelection}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showApprovalWarning}
        PaperProps={{
          sx: WARNING_DAILOG_WRAPPER,
        }}
        onClose={() => setShowApprovalWarning(false)}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack spacing={3}>
            <Stack spacing={3} sx={WARNING_DAILOG_HEADER}>
              <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                <WarningAmber style={{ fontSize: 18, color: "#B04509" }} />
                <Typography sx={WARNING_DAILOG_TITLE}>Warning</Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {updatedItems.length === 1
                      ? `You have modified one entry. By selecting Mass Approval you
                    will lose any changes made for the modified record.`
                      : `You have modified more than one entries. By selecting Mass Approval you
                    will lose any changes made for the modified records.`}
                  </Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {"Please click on save to incorporate changes"}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack spacing={2}>
              <Typography sx={WARNING_DAILOG_ACTION_TEXT}>
                Would you like to select all entries for Mass Approval?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_NO}
                  onClick={onDeniedApproval}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_YES}
                  onClick={() => {
                    onConfirmAllSelection();
                    setIsAllSelected(true);
                    setShowApprovalWarning(false);
                  }}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showWarning}
        PaperProps={{
          sx: WARNING_DAILOG_WRAPPER,
        }}
        onClose={() => setShowWarning(false)}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack spacing={3}>
            <Stack spacing={3} sx={WARNING_DAILOG_HEADER}>
              <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                <WarningAmber style={{ fontSize: 18, color: "#B04509" }} />
                <Typography sx={WARNING_DAILOG_TITLE}>Warning</Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {updatedItems.length === 1
                      ? `You have modified one entry, by performing this action
                    existing modified record will not be saved`
                      : `You have modified more than one entries, by performing this action
                    existing modified records will not be saved`}
                  </Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {"Please click on save to incorporate changes"}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack spacing={2}>
              <Typography sx={WARNING_DAILOG_ACTION_TEXT}>
                Would you like to proceed?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_NO}
                  onClick={() => setShowWarning(false)}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_YES}
                  onClick={handleConfirmProcess}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showModificationWarning}
        PaperProps={{
          sx: WARNING_DAILOG_WRAPPER,
        }}
        onClose={() => {
          setModifiedItem(null);
          setShowModificationWarning(false);
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack spacing={3}>
            <Stack spacing={3} sx={WARNING_DAILOG_HEADER}>
              <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                <WarningAmber style={{ fontSize: 18, color: "#B04509" }} />
                <Typography sx={WARNING_DAILOG_TITLE}>Warning</Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {
                      "You have modified this entry. By unchecking, you will lose the existing changes."
                    }
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack spacing={2}>
              <Typography sx={WARNING_DAILOG_ACTION_TEXT}>
                Would you like to proceed?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_NO}
                  onClick={() => {
                    setModifiedItem(null);
                    setShowModificationWarning(false);
                  }}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_YES}
                  onClick={handleModificationConfirmProcess}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showMassApprovalPending}
        autoHideDuration={6000}
        onClose={() => setShowMassApprovalPending(false)}
        sx={{ maxWidth: 405 }}
      >
        <Alert
          icon={<Error sx={{ color: "#282C36" }} />}
          onClose={() => setShowMassApprovalPending(false)}
          sx={{
            background: "#FAF3E3",
            borderRadius: "4px",
            width: "100%",
            color: "#282C36",
            fontSize: 13,
            lineHeight: "18px",
            fontWeight: 500,
          }}
        >
          Your request is under process. It may take a few minutes to approve
          all the records
        </Alert>
      </Snackbar>

      <Dialog
        onClose={() => setOpenImageCarousel(false)}
        open={openImageCarousel}
        PaperProps={{
          sx: {
            padding: 3,
            maxWidth: 822,
          },
        }}
      >
        <Stack spacing={2} flex={1}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            flex={1}
          >
            <Typography sx={CAROUSEL_HEADER}>
              {`UPC ${imageCarouselUPC}` || ""}
            </Typography>
            <IconButton onClick={() => setOpenImageCarousel(false)}>
              <Close sx={{ fontSize: 18, color: "#6F7784" }} />
            </IconButton>
          </Stack>
          <Stack>
            <Carousel
              axis={"horizontal"}
              showIndicators={false}
              showStatus={false}
              showThumbs={true}
              selectedItem={selectedCarouselImage}
              renderArrowPrev={(onClickHandler, hasPrev, label) => (
                <IconButton
                  aria-label="prev"
                  onClick={onClickHandler}
                  title={label}
                  sx={{
                    ...CAROUSEL_BTN,
                    left: "-16px",
                    visibility: hasPrev ? "visible" : "hidden",
                  }}
                >
                  <ChevronLeft />
                </IconButton>
              )}
              renderArrowNext={(onClickHandler, hasNext, label) => (
                <IconButton
                  aria-label="prev"
                  onClick={onClickHandler}
                  title={label}
                  sx={{
                    ...CAROUSEL_BTN,
                    right: "-16px",
                    visibility: hasNext ? "visible" : "hidden",
                  }}
                >
                  <ChevronRight />
                </IconButton>
              )}
              renderThumbs={() =>
                carouselImages?.map((th: any, i: number) => {
                  return (
                    <img
                      key={`thumb-${i}`}
                      src={
                        isValidHttpUrl(th.Image)
                          ? th.Image
                          : `${window?.location?.origin}/${th.Image}`
                      }
                      alt={`thumb-${i}`}
                      style={{
                        height: "100%",
                        width: "auto",
                        overflow: "hidden",
                        objectFit: "contain",
                      }}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = PRODUCT_PLACEHOLDER;
                      }}
                    />
                  );
                })
              }
            >
              {carouselImages?.map((ci: any, index: number) => (
                <Stack
                  key={`carousel-${index}`}
                  spacing={2}
                  alignItems={"center"}
                  sx={{
                    background: "#FFFFFF",
                    border: "1px solid rgba(15, 61, 97, 0.08)",
                    borderRadius: "8px",
                    padding: 2,
                    maxHeight: 700,
                  }}
                >
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        lineHeight: "16px",
                        fontWeight: 600,
                        color: "#6F7784",
                        textTransform: "uppercase",
                      }}
                    >
                      {getImageType(ci?.ImageType)}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                        lineHeight: "16px",
                        fontWeight: 600,
                        color: "#6F7784",
                      }}
                    >{`${index + 1} of ${carouselImages.length}`}</Typography>
                  </Stack>
                  <img
                    src={
                      isValidHttpUrl(ci.Image)
                        ? ci.Image
                        : `${window?.location?.origin}/${ci.Image}`
                    }
                    alt={`carousel-${index}`}
                    style={{
                      height: "100%",
                      maxHeight: 612,
                      maxWidth: 612,
                      width: "auto",
                      overflow: "hidden",
                      objectFit: "contain",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = PRODUCT_PLACEHOLDER;
                    }}
                  />
                </Stack>
              ))}
            </Carousel>
          </Stack>
        </Stack>
      </Dialog>
    </Box>
  );
};

export default view(Products);
